export default "__VITE_ASSET__DWlB3a3z__"